import { Building2, Eye, EyeOff } from "lucide-react";

// Anteprima della vetrina pubblica "Cooperative convenzionate" dentro l'Area Agenzia.
export const VetrinaPreview = ({ items, onToggle }) => {
  const pubblicate = items.filter((c) => c.in_vetrina && c.attivo !== false && c.cooperativa_nome);
  return (
    <div className="rounded-2xl border border-border/60 bg-white p-5" data-testid="vetrina-preview">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h2 className="font-heading text-lg font-semibold text-forest">Anteprima vetrina · {pubblicate.length} cooperative pubblicate</h2>
        <span className="text-xs text-muted-foreground">Compare chi ha «Nome cooperativa», è attiva e ha «Pubblica in vetrina».</span>
      </div>
      {pubblicate.length === 0 ? (
        <p className="mt-3 rounded-lg bg-sage/50 p-3 text-sm text-forest" data-testid="vetrina-empty">
          Nessuna cooperativa in vetrina. Crea una convenzione con «Nuova convenzione», compila «Nome cooperativa» e spunta «Pubblica in vetrina», oppure usa il pulsante con l'occhio nella tabella.
        </p>
      ) : (
        <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {pubblicate.map((c) => (
            <div key={c.id} className="flex items-center gap-3 rounded-xl border border-border/60 p-3" data-testid={`vetrina-card-${c.codice}`}>
              {c.logo_url ? <img src={c.logo_url} alt="" className="h-10 w-10 rounded object-contain" /> : <Building2 className="h-10 w-10 text-forest/40" />}
              <div className="min-w-0 flex-1">
                <div className="truncate text-sm font-semibold text-forest">{c.cooperativa_nome}</div>
                <div className="text-xs text-muted-foreground">{c.codice} · {c.n_richieste || 0} richieste</div>
              </div>
              <button onClick={() => onToggle(c)} title="Togli dalla vetrina" data-testid={`vetrina-hide-${c.codice}`} className="text-muted-foreground hover:text-red-600"><EyeOff className="h-4 w-4" /></button>
            </div>
          ))}
        </div>
      )}
      {items.some((c) => !c.in_vetrina && c.cooperativa_nome) && (
        <div className="mt-3 flex flex-wrap gap-2 text-xs">
          <span className="text-muted-foreground">Non pubblicate:</span>
          {items.filter((c) => !c.in_vetrina && c.cooperativa_nome).map((c) => (
            <button key={c.id} onClick={() => onToggle(c)} data-testid={`vetrina-show-${c.codice}`} className="inline-flex items-center gap-1 rounded-full border border-forest/30 px-2 py-0.5 text-forest hover:bg-sage">
              <Eye className="h-3 w-3" />{c.cooperativa_nome}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
